module.exports = __webpack_public_path__ + "img/Bash.aeb6a484.png";